<template>
  <div class="shop-container">
    <section class="order-info-box mb24">
      <div class="form-type ponhu-line" @click="showDelivery=true" v-if="channel_id!='34'">
        <div class="form-type_lable fw">配送方式</div>
        <div class="form-type_value">
          <span class="value">{{orderForm.expressTypeCode == '1' ? '快递到家' : '到店自提（仅支持北京自提）' }}</span>
          <van-icon name="arrow" size="18px" slot="left" />
        </div>
      </div>
      <div class="form-type ponhu-line" v-if="orderForm.expressTypeCode == '2'">
        <div class="form-type_lable fw">自提地址</div>
        <div class="zt-warp">
          <p>{{select_ziti.address}}</p>
          <p style="margin-top: 0;">{{select_ziti.phone}}</p>
        </div>
      </div>
      <div class="form-type entrust_pub ponhu-line">
        <div class="form-type_lable fw">收货人</div>
        <input type="text" placeholder="请填写收货人姓名" v-model="orderForm.receiver" class="van-field__control">
      </div>
      <div class="form-type entrust_pub ponhu-line">
        <div class="form-type_lable fw">手机号码</div>
        <input type="tel" placeholder="请填写手机号码，用于查询订单" v-model="orderForm.tel" class="van-field__control">
      </div>
      <div class="form-type ponhu-line" @click="showAddress=true" v-if="orderForm.expressTypeCode == '1'">
        <div class="form-type_lable fw">所在地区</div>
        <div class="value-warp" v-if="!addressValue">省市区县、乡镇等</div>
        <div class="value-warp" style="color: #222222" v-else>{{addressValue}}</div>
        <div class="form-type_value">
          <van-icon name="arrow" size="18px" slot="left" />
        </div>
      </div>
      <div class="form-type entrust_pub ponhu-line" v-if="orderForm.expressTypeCode == '1'">
        <div class="form-type_lable fw">详细地址</div>
        <input type="text" v-model="orderForm.detailedAddress" placeholder="请填写详细收货地址" class="van-field__control">
      </div>
      <div class="bottom-line">
        <img src="@/assets/img/balance-line_new.png" alt="">
      </div>
    </section>
    <section class="goods-info-box mb24">
      <div class="goods-item">
        <div class="img-box">
          <img :src="goods.firstPicture + '?imageView2/1/w/300/h/300'" alt="" srcset="">
        </div>
        <div class="goods-content fz24">
          <div class="goods-title">{{goods.description}}</div>
          <div class="goods-bottom">
            <div class="price"><span class="fz24">¥</span>{{goods.discountPrice}}</div>
          </div>
        </div>
      </div>
      <div class="form-type ponhu-line">
        <div class="form-type_lable fw">买家留言</div>
        <div placeholder="请输入留言" v-html="orderForm.message" @blur="orderForm.message=$event.target.innerText" contenteditable="true" class="van-field__control tex"></div>
      </div>
      <div class="form-type ponhu-line" v-if="isVTk" @click="gotk">
        <div class="form-type_lable fw">泰康承保</div>
        <div class="form-type_value">
          <span class="value">进入泰康主页</span>
          <van-icon name="arrow" size="18px" slot="left" />
        </div>
      </div>
    </section>
    <section class="pay-method-box">
      <van-radio-group v-model="orderForm.payCode">
        <van-cell-group>
          <van-cell title="微信支付" clickable v-if="ifShow" @click="orderForm.payCode='2'">
            <van-icon slot="icon" name="wechat" color="#00C800" size="22px" style="margin-right: 10px" />
            <van-radio name="2" checked-color="#FFD133" />
          </van-cell>
          <van-cell title="支付宝支付" @click="orderForm.payCode='1'">
            <van-icon slot="icon" name="alipay" color="#00AAEE" size="22px" style="margin-right: 10px" />
            <van-radio name="1" checked-color="#FFD133" />
          </van-cell>
          <van-cell title="网银转账" @click="orderForm.payCode='5'" v-if="channel_id!='34'">
            <svg-icon slot="icon" iconClass="unionpay" class="ph-icon" style="margin-right: 10px;font-size:22px"></svg-icon>
            <van-radio name="5" checked-color="#FFD133" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </section>
    <div class="order-submit-box">
      <div class="bar-warp">
        <div class="text">
          <span>实付款：</span>
          <span class="price">￥{{orderForm.orderAmount}}</span>
        </div>
        <div class="btn-box" :class="!isDisable?'opacity':''" @click="orderSubmit">
          <span v-if="isDisable">立即支付</span>
          <div v-else>
            <van-loading size="20">支付中...</van-loading>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="showDelivery" title="选择配送方式">
      <div class="actions-delivery">
        <van-radio-group v-model="select_expressType">
          <van-cell-group>
            <van-cell title="快递到家" clickable @click="select_expressType='1'">
              <van-radio name="1" checked-color="#FFD133" />
            </van-cell>
            <div class="title">到店自提</div>
            <van-cell v-for="item in ziti_list" :key="item.id" title="" clickable @click="select_expressType=item.id">
              <van-radio :name="item.id" checked-color="#FFD133" />
              <template #label>
                <div class="zt-des">
                  <p>{{item.contact}} {{item.phone}}</p>
                  <p>{{item.address}}</p>
                  <p style="margin-top: 0;"></p>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div class="footer-box">
          <van-button type="ponhu" size="large" @click="onDelivery" class="fw">确认</van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-popup v-model="showTig" style="background:transparent" :close-on-click-overlay="false">
      <div class="store-popup">
        <img src="@/assets/img/alipay_tig.png" />
        <div class="btn-box">
          <div class="button-group">
            <van-button round type="ponhu" class="clip-btn" @click="onCopy" size="large">复制链接去支付</van-button>
            <div class="def" @click="showTig=false">我再看看</div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showAddress" round position="bottom">
      <van-cascader
        v-model="select_address"
        title="请选择所在地区"
        :options="addressOptions"
        @close="showAddress = false"
        @finish="onFinishAddress"
      />
    </van-popup>
    <div v-html="alipayWap" ref="alipayWap"></div>
  </div>
</template>

<script>
import { getSalePaymentCommodity, getMultipleSelfLiftingAddress, payWeChat, payAli, createSaleOrder, checkPayment } from '@/api/order'
import { BrowserInfo } from '@/utils'
import { getAreaList } from '@/api/user'
import { validatMobile } from '@/utils/validate'
import { setLocalStorage, getLocalStorage } from '@/utils'
import ClipboardJS from 'clipboard'

export default {
  data() {
    return {
      channel_id: '',
      goods_id: '',
      sale_id: '',
      openid: '',
      soNumber: '',
      uToken: '',
      paytype: '',
      isVTk: false,
      orderForm: {
        os: '2',
        osVersion: '1.0.0',
        userSource: '',
        goodsId: [],
        specialSaleIds: [],
        payCode: '2',
        orderAmount: 0,
        expressTypeCode: '1',
        message: '',
        cityId: '',
        connection: '',
        detailedAddress: '',
        tel: '',
        provinceId: '',
        receiver: '',
        areaId: '',
        addressId: ''
      },
      goods: {},
      ziti_list: [],
      select_ziti: {},
      select_expressType: '1',
      addressOptions: [],
      showAddress: false,
      select_address: '',
      addressValue: '',
    
      showDelivery: false,
      isDisable: true,
      showTig: false,
      submit_loading: false,
      alipayWap: '',
      ifShow: true,
    }
  },
  created() {
    this.goods_id = this.$route.params.gid
    this.orderForm.goodsId.push(this.goods_id)

    this.channel_id = this.$route.query.channel;
    this.orderForm.userSource = this.channel_id;
    this.sale_id = this.$route.query.sale;
    this.orderForm.specialSaleIds.push(this.sale_id);
    this.openid = this.$route.query.openid || ''

    var balance = this.$store.getters.onLineBalance;
    if(typeof(balance.tel) != "undefined" || typeof(balance.receiver) != "undefined" || typeof(balance.connection) != "undefined" || typeof(balance.detailedAddress) != "undefined" || typeof(balance.addressId) != "undefined") {
      this.orderForm = balance;
      this.addressValue = balance.connection;
      if(balance.addressId) {
        this.select_expressType = balance.addressId;
      }
    }

    this.getInitAreaList();
    this.getData();
  },
  mounted() {
    this.soNumber = this.$route.query.oid || ''
    this.paytype = this.$route.query.pay || '1'
    if(this.soNumber) {
      // 验证订单是否支付
      checkPayment({ orderNumber: this.soNumber, payMethodId: this.paytype, businessCode: 'UNPAID_CLOSE_ORDER' }).then(res => {
        if(res) {
          this.$router.replace('/online/pay/success?so='+this.soNumber)
        } else {
          this.$router.replace('/online/pay/fail?so='+this.soNumber)
        }
      })
    }
    if (BrowserInfo().isWeixin) {
      if (window.location.href.indexOf("?#") < 0) {
        window.location.replace(window.location.href.replace("#", "?#"));
      }
    } else {
      this.ifShow = false;
      this.orderForm.payCode = '1';
    }
  },
  methods: {
    // 获取数据
    getData() {
      // 获取结算页信息
      getSalePaymentCommodity({ orderCommodityIds: this.orderForm.goodsId, specialSaleIds: this.orderForm.specialSaleIds }).then(res => {
        this.goods = res.commodityList[0];
        this.orderForm.orderAmount = res.totalAmount;
        this.isVTk = res.underwriting;
        // 获取自提地址
        getMultipleSelfLiftingAddress().then(zres => {
          this.ziti_list = zres;
          this.ziti_list.forEach(item => {
            if(item.id == this.select_expressType) {
              this.select_ziti = item;
            }
          })
        })
      })
    },
    getInitAreaList () {
      var _that = this;
      getAreaList().then(res => {
        this.$nextTick(() => {
          _that.addressOptions = res;
        })
      }).catch(err => {
        this.$toast(err)
      })
    },
    gotk () {
      this.$store.commit('SET_USER_ONLINE_BALANCE', this.orderForm);
      this.$router.push({ name: 'taikang', query: { gid: this.goods_id, flag: 'online' } })
    },
    //复制
    onCopy () {
      let that = this
      var url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/' + this.goods_id + '?channel='+this.channel_id+'&sale='+this.sale_id;
      if(this.channel_id=='34') {
        url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/goods?channel='+this.channel_id+'&sale='+this.sale_id;
      }
      var clipboard = new ClipboardJS('.clip-btn', {
        text: function (trigger) {
          return url
        }
      })
      clipboard.on('success', function (e) {
        that.$toast('地址已经复制到粘贴板！')
        e.clearSelection()
      })

      clipboard.on('error', function (e) {
        that.$toast('该设备不支持自动复制')
      })
      this.showTig = false
    },
    // 选择配送
    onDelivery() {
      if (this.select_expressType == '1') {
        this.orderForm.expressTypeCode = '1';
        this.orderForm.addressId = '';
      } else {
        this.ziti_list.forEach(item => {
          if(item.id == this.select_expressType) {
            this.select_ziti = item;
            this.orderForm.expressTypeCode = '2';
            this.orderForm.addressId = item.id;
            this.orderForm.provinceId = '';
            this.orderForm.cityId = '';
            this.orderForm.areaId = '';
            this.orderForm.connection = '';
            this.orderForm.detailedAddress = '';
          }
        })
      }
      this.showDelivery = false;
    },
    // 地区选择完毕触发
    onFinishAddress({ selectedOptions }) {
      this.showAddress = false;
      this.addressValue = selectedOptions.map((option) => option.text).join('');
      this.orderForm.connection = this.addressValue;
      this.orderForm.provinceId = selectedOptions[0].value;
      this.orderForm.cityId = selectedOptions[1].value;
      this.orderForm.areaId = selectedOptions[2].value;
    },

    // 订单提交
    orderSubmit() {
      let bro = BrowserInfo();
      if(this.orderForm.payCode == '1') {
        if(bro.isWeixin) {
          this.showTig = true;
          return false;
        }
      }

      if(!this.isDisable) return;
      if (!validatMobile(this.orderForm.tel)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!this.orderForm.receiver) {
        this.$toast('请输入收货人姓名')
        return
      }
      if(this.orderForm.expressTypeCode == '1') {
        if (!this.orderForm.provinceId || !this.orderForm.cityId || !this.orderForm.areaId) {
          this.$toast('请选择所在地区')
          return
        }
        if (!this.orderForm.detailedAddress) {
          this.$toast('请输入详细地址')
          return
        }
      }
      this.isDisable = false;
      console.log(this.orderForm)

      // 创建订单
      createSaleOrder(this.orderForm).then(res => {
        this.soNumber = res.soNumber;
        this.uToken = res.userToken;
        this.$store.dispatch('LoginByUser', res.userToken)
        if(this.orderForm.payCode == '5') {
          this.$router.replace({ name: 'Epay', params: { oid: this.soNumber } })
        } else if (this.orderForm.payCode === '1') {  // 支付宝支付
          this.alipaySubmit()
        } else {
          this.wechatSubmit()
        }
        // 清理结算缓存
        this.$store.dispatch('OnlineBalanceOut')
      }).catch(err => {
        this.isDisable = true;
        this.$toast(err)
      });
    },
    // 微信支付提交
    wechatSubmit() {
      let bro = BrowserInfo()
      var payModel = {
        body: 'h5商品购买' + this.soNumber,
        out_trade_no: this.soNumber,
        total_fee: this.orderForm.orderAmount,
        attach: this.uToken,
        notify_url: process.env.VUE_APP_BASE_API + '/miniapps/payCallApi/payCommodityCallbackWX',
        trade_type: '',
        scene_info: '',
        openid: this.openid,
        business_code: 'BUY_GOODS_VERIFY_INVENTORY'
      }
      if (bro.isWeixin) { // 微信内置
        payModel.trade_type = 'JSAPI'
      } else {
        payModel.trade_type = 'MWEB'
      }
      // 唤起支付
      payWeChat(payModel).then(data => {
        if (bro.isWeixin) { // 微信内置
          this.weixinPay(data)
        } else {
          var url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/' + this.goods_id + '?channel='+this.channel_id+'&sale='+this.sale_id + '&oid='+this.soNumber;
          if(this.channel_id=='34') {
            url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/goods?channel='+this.channel_id+'&sale='+this.sale_id + '&oid='+this.soNumber;
          }
          window.location.replace(data.url + '&redirect_url=' + encodeURIComponent(url))
        }
      }).catch(err => {
        this.isDisable = true;
        this.$toast(err)
      })
    },
    chackPay() {
      // 验证订单是否支付
      checkPayment({ orderNumber: this.soNumber, payMethodId: this.orderForm.payCode, businessCode: 'UNPAID_CLOSE_ORDER' }).then(res => {
        if(res) {
          this.$router.replace('/online/pay/success?so='+this.soNumber)
        } else {
          this.$router.replace('/online/pay/fail?so='+this.soNumber)
        }
      })
    },
    weixinPay (data) {
      var vm = this
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
        }
      } else {
        vm.onBridgeReady(data)
      }
    },
    onBridgeReady (data) {
      var that = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          debug: true,
          'appId': data.appId,
          'timeStamp': data.timeStamp,
          'nonceStr': data.nonceStr,
          'package': data.payPackage,
          'signType': data.signType,
          'paySign': data.paySign,
          jsApiList: ['chooseWXPay']
        },
        function (res) {
          that.chackPay();
        }
      )
    },
    // 支付宝支付提交
    alipaySubmit() {
      var return_url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/' + this.goods_id + '?channel='+this.channel_id+'&sale='+this.sale_id + '&oid='+this.soNumber + '&pay='+this.orderForm.payCode;
      if(this.channel_id=='34') {
        return_url = process.env.VUE_APP_ROOT_URL + 'index.html#/online/settlement/goods?channel='+this.channel_id+'&sale='+this.sale_id + '&oid='+this.soNumber + '&pay='+this.orderForm.payCode;
      }
      var payModel = {
        body: 'h5商品购买' + this.soNumber,
        subject: '订单号' + this.soNumber,
        out_trade_no: this.soNumber,
        total_amount: this.orderForm.orderAmount,
        trade_type: 'MWEB',
        notify_url: process.env.VUE_APP_BASE_API + '/miniapps/payCallApi/payCommodityCallbackZFB',
        passback_params: this.uToken,
        quit_url: return_url,
        specified_channel: '',
        return_url: return_url,
        business_code: 'BUY_GOODS_VERIFY_INVENTORY'
      }
      // 唤起支付
      payAli(payModel).then(data => {
        this.alipayWap = data;
				this.$nextTick(() => {
          this.$refs.alipayWap.children[0].submit()
        })
      }).catch(err => {
        this.isDisable = true;
        this.$toast(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-info-box {
  position: relative;
  margin-top: 24px;
  color: #333333;
  .form-type {
    padding: 0 14px 0 24px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    line-height: 88px;
    &_lable{ 
      width: 200px;
    }
    &_value{
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #999999;
      position: relative;
      .value {
        margin-right: 10px;
        color: #222222;
      }
    }
    .zt-warp {
      display: block;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
      p {
        line-height: 36px;
        font-size: 24px;
        color: #222222;
        margin-bottom: 0px;
      }
    }
    .value-warp {
      display: block;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
      color: #222222;
      line-height: inherit;
      text-align: left;
      font-size: 24px;
      color: #999999;
      padding-left: 10px;
    }
    input {
      font-size: 24px;
      color: #222222;
      height: 42px;
      line-height: 42px;
    }
    .bottom-line{
      display: flex;
      width: 100%;
    }
  }
  .entrust_pub{
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
  }
}
.goods-info-box {
  .goods-item {
    background: #fff;
    height:192px;
    position: relative;
    color: #333333;
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid #EEEEEE;
    .img-box{
      width: 144px;
      img{
        display: block;
        width: 144px;
        height: 144px;
      }
    }
    .goods-content{
      position: relative;
      display: flex;
      flex: 1;
      height: 90px;
      flex-direction: column;
      min-width: 0;
      flex: auto;
      margin-left: 24px;
      font-weight: 400;
      .goods-bottom{
        margin-top: 40px;
        display: flex;
        align-items: center;
        flex: 1;
        .price{
          font-size: 32px;
          font-weight:500;
          color:#DA3232;
        }
        .dis {
          margin-left: 20px;
          font-size: 24px;
          color: #999999;
          font-weight: 500;
        }
      }
    }
  }
  .form-type {
    padding: 0 14px 0 24px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    line-height: 98px;
    color: #333333;
    &_lable{ 
      width: 200px;
    }
    &_value{
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #999999;
      position: relative;
      .value {
        margin-right: 10px;
        color: #999999;
      }
    }
    .tex {
      font-size: 24px;
      color: #222222;
      line-height: 30px;
      display: flex;
      align-items: center;
      padding: .45rem 0;
    }
  }
}
.order-submit-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  -webkit-user-select: none;
  user-select: none;
  .bar-warp {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    height: 98px;
    padding-left: 24px;
    font-size: 28px;
    .text {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      color: #222222;
      text-align: left;
      span {
        display: inline-block;
      }
      .price {
        color: #DA3232;
        font-weight: 500;
        font-size: 32px;
      }
    }
    .btn-box {
      width: 240px;
      height: 98px;
      background: #DA3232;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
      }
    }
    .opacity {
      opacity:0.6
    }
  }
}
.pay-method-box{
  padding-bottom: 122px;
  .van-radio{
    display: flex;
    justify-content: flex-end;
  }
}
.zt-des {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  p {
    line-height: 36px;
    font-size: 24px;
    color: #999999;
    margin-bottom: 0px;
    margin-top: 10px;
  }
}
.store-popup{
  width:554px;
  box-sizing: border-box;
  position: relative;
  background: transparent;
  img {
    width:554px;
    height: 364px;
  }
  .btn-box {
    margin-top: 60px;
    display: flex;
    justify-content:center;
    align-items: center;
    .button-group {
      width:100%;
      .def {
        height: 110px;
        font-size: 28px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 110px;
        display: flex;
        justify-content:center;
        align-items: center;
      }
    }
  }
}
.actions-delivery{
  .van-radio-group{
    margin-bottom: 50px;
  }
  .van-radio{
    display: flex;
    justify-content: flex-end;
  }
  .footer-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .title {
    color: #333333;
    font-size: 14PX;
    padding: 24px;
  }
}
.van-cell {
  color: #333333;
  padding: 10px 12px;
}
.van-cell__title {
  width: 80%;
  flex: auto;
}
::-webkit-input-placeholder { /* WebKit browsers */
  color: #999999;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #999999;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #999999;
}
div:empty:before{
  content: attr(placeholder);
  color:#999999;
}
div:focus:before{
  content:none;
}
</style>


